// Angular
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// Rxjs
import { combineLatest, of, Subject, Subscription } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
// Models
import { ISelectedStore } from '@core/services-v2/geolocation/models/geolocation.interface';
// Components
import { ModalStoresComponent } from '../../modal-stores/modal-stores.component';
// Services
import { MenuStateService } from '../services/menu-state.service';
import { DropdownDirective } from '../../../../../shared/directives/dropdown.directive';
import { LocalStorageService } from 'src/app/core/modules/local-storage/local-storage.service';
import { GeolocationServiceV2 } from '@core/services-v2/geolocation/geolocation.service';
import { StorageKey } from '@core/storage/storage-keys.enum';
import { CartService } from '@core/services-v2/cart.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ISession } from '@core/models-v2/auth/session.interface';
import { SessionService } from '@core/services-v2/session/session.service';
import { AuthStateServiceV2 } from '@core/services-v2/session/auth-state.service';
import { ModalVehicleComponent } from '../../modal-vehicle/modal-vehicle.component';
import { environment } from '@env/environment';
import { MenuService } from '@core/services-v2/menu/menu.service';
import { CategoryService } from '@core/services-v2/category/services/category.service';
import { FirstLevelMenuItem, MenuItem } from '../models';
import { MenuApiService } from '../services';
@Component({
  selector: 'app-menu-categoria-mobile',
  templateUrl: './menu-categoria-b2c-mobile.component.html',
  styleUrls: ['./menu-categoria-b2c-mobile.component.scss'],
})
export class MenuCategoriaMobileComponent implements OnInit {
  @ViewChild('menuTienda', { static: false }) menuTienda!: DropdownDirective;
  isSearchVehicleVisible: boolean;

  usuario!: ISession;
  usuarioRef!: Subscription;

  selectedStore!: ISelectedStore;
  orderTrackingVisible: boolean = environment.visibility.orderTracking;

  // menu
  private destroy$: Subject<any> = new Subject();
  menuCategoriesItems: FirstLevelMenuItem[] = [];
  menuItems: MenuItem[] = [];
  isOpen: boolean = false;

  private readonly categoryService: CategoryService = inject(CategoryService);
  public readonly menuStateService: MenuStateService =
    inject(MenuStateService);
  private readonly menuApiService: MenuApiService = inject(MenuApiService);

  constructor(
    private router: Router,
    public localS: LocalStorageService,
    private readonly geolocationService: GeolocationServiceV2,
    private readonly cartService: CartService,
    public readonly modalServices: NgbModal,
    private readonly sessionService: SessionService,
    private readonly authStateService: AuthStateServiceV2,
    private readonly menuService: MenuService
  ) {
    this.isSearchVehicleVisible = environment.visibility.searchVehicle;
    this.selectedStore = this.geolocationService.getSelectedStore();
  }

  ngOnInit(): void {
    this.menuStateService.isOpen$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen) => (this.isOpen = isOpen));

    this.fetchMenus();

    this.geolocationService.selectedStore$.subscribe({
      next: (selectedStore) => {
        this.selectedStore = selectedStore;
        this.cartService.calc();
        if (selectedStore.isChangeToNearestStore) {
          setTimeout(() => {
            if (this.menuTienda) this.menuTienda.open();
          }, 700);
        }
      },
    });
    //Usuario
    this.usuario = this.sessionService.getSession();
    this.usuarioRef = this.authStateService.session$.subscribe((user) => {
      this.usuario = user;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  showStores(): void {
    this.modalServices.open(ModalStoresComponent, { size: 'md' });
  }
  showVehicle(): void {
    const modalRef = this.modalServices.open(ModalVehicleComponent, {
      size: 'md',
    });
    modalRef.result.then((closeMenu: boolean) => {
      if (closeMenu) {
        setTimeout(() => this.menuStateService.close(), 100);
        setTimeout(() => this.menuService.openLoginDropdown(), 300);
      }
    });
  }

  async validarCuenta() {
    this.localS.set(StorageKey.ruta, ['/', 'mi-cuenta', 'seguimiento']);
    this.router.navigate(['/mi-cuenta', 'seguimiento']);
  }

  /**
   * Obtener elementos del menú.
   */
  private fetchMenus(): void {
    const menuItems$ = this.menuApiService.getMenu().pipe(
      catchError((err) => {
        console.error('Error fetching menu items:', err);
        return of([]); // Retorna array vacío si falla
      })
    );

    const categories$ = this.categoryService.getMenuCategories().pipe(
      catchError((err) => {
        console.error('Error fetching categories:', err);
        return of({ items: [] }); // Retorna objeto con items vacío si falla
      })
    );

    combineLatest([menuItems$, categories$])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ([menuItems, categories]) => {
          this.menuItems = menuItems;
          this.menuCategoriesItems = categories.items;
        },
        error: (err) => {
          console.error('Unexpected error in menu loading:', err);
        },
      });
  }
  //Redirecciona a la vista de todos los productos
  goToAllProducts(): void {
    this.router.navigate(['/inicio/productos/todos']);
    this.menuStateService.close();
  }
}
